class ModalLoading {
    constructor(modalToOpen = null) {
        this.initLoading(modalToOpen);
    }
    initLoading(modalToOpen){
        const body = document.querySelector('#kt_app_body');
        if(body){
            let blockUI = KTBlockUI.getInstance(body);
            if(!blockUI){
                blockUI = new KTBlockUI(body, {
                    overlayClass: 'blockui-backdrop',
                    overflow: '',
                    message:
                        '<span class="bg-light-primary p-5 rounded text-primary">' +
                        '   <span class="spinner-border spinner-border-sm align-middle me-2"></span> Opening...' +
                        '</span>'
                });
            }
            if (blockUI.isBlocked()) {
                if(modalToOpen){
                    bootstrap.Modal.getOrCreateInstance(modalToOpen, {}).show();
                }
                blockUI.release();
            } else {
                blockUI.block();
            }
        }
    }
}
window.ModalLoading = ModalLoading;